import {exeRequest} from '../utils/APIUtils'

export default {
//  get : async  (dates, concessionnaireId) => exeRequest(`/operations?dateDebut=${dates.debut}&dateFin=${dates.debut}&concessionnaireId=${concessionnaireId}`, "GET")
  get : async  (dates, concessionnaireId) => exeRequest(`/operations?dateDebut=${dates.debut}&dateFin=${dates.fin}&concessionnaireId=${concessionnaireId}`, "GET")
}